/**
 * Created by lihanying on 2018/4/11.
 */
import React from 'react'

const Items = (props) => {
  return (
    <div className="info-item">
      <div>{props.title}</div>
      <div>{props.value}</div>
    </div>
  )
}
export default Items



// WEBPACK FOOTER //
// ./src/containers/ClubInfo/component/items.js